<template>
  <div class="page">
    <div class="container">
      <div class="page-contacts">
        <img class="big-logo" src="@/assets/images/big-logo.svg" alt="">

        <div class="map">
          <img src="@/assets/images/map3.jpg" alt="">
          <div class="map__pin"></div>
        </div>

        <form class="contacts-form" @submit.prevent="submit">
          <div class="contacts-form__info">
            <p><a href="tel:+74952408268">+7 (495) 240 82 68</a></p>
            <br>
            <!-- <p>117036, Moscow<br> Pr. 60-letiya Oktyabrya, 10A</p> -->
            <p>117312, Москва,<br>пр. 60-летия Октября, 10А<br>БЦ Принципал Плаза</p>
          </div>

          <div class="contacts-form__actions">
            <div class="contacts-callback" v-if="!sent">
              <div class="contacts-callback__col">
                <input type="email" class="input" placeholder="Email" required>
                <input type="text" class="input" placeholder="Name" required>
                <textarea class="input input_textarea" placeholder="Question" required/>
              </div>
              <div class="contacts-callback__col">
                <button class="button page__btn" :disabled="sending">Отправить</button>
              </div>
            </div>
            <div class="contacts-callback contacts-callback_success" v-else>Успешно отправлено!</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import Axios from 'axios'

export default {
  name: 'contacts',
  data () {
    return {
      sending: false,
      sent: false,
      name: '',
      email: '',
      message: ''
    }
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.big-logo', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.contacts-form__info', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.contacts-form__actions', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.map', 0.5, { opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    new TimelineMax()
      .add(TweenMax.to('.map', 0.5, { opacity: 0 }))
      .add(TweenMax.to('.contacts-form__actions', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.contacts-form__info', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.big-logo', 0.3, { y: '30px', opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  },
  methods: {
    submit () {
      if (this.sending) {
        return
      }
      this.sending = true
      Axios.post('/contact.php', {
        data: {
          name: this.name,
          email: this.email,
          message: this.message
        }
      })
        .then((response) => {
          console.log(response)
          this.sent = true
          setTimeout(() => {
            this.sent = false
          }, 3000)
        })
        .catch((error) => {
          console.log(error)
          this.sent = true
          setTimeout(() => {
            this.sent = false
          }, 3000)
        })
        .finally(() => {
          this.sending = false
        })
    }
  }
}
</script>
